import { z } from 'zod';

/** Six hex digits, `#`-prefixed — the one colour notation the `color` control writes. */
export const HEX_COLOR_RULE = /^#[0-9a-fA-F]{6}$/u;

/**
 * A per-brand override of the runtime-themable accent — `brand.accentColor`.
 *
 * Empty means "use the build's design token", which is the default on purpose:
 * the accent belongs to the token system (U6), and duplicating a token's value
 * here would make a second source of truth for a colour. A hex value replaces
 * exactly one token pair (`accent` / `accent-foreground`) at runtime — deeper
 * palette changes stay build-time.
 */
export const AccentColorSchema = z.union([z.literal(''), z.string().regex(HEX_COLOR_RULE)]);

export type AccentColor = z.infer<typeof AccentColorSchema>;

/** The registry's coded default: no override, the build's token. */
export const NO_ACCENT_OVERRIDE: AccentColor = '';
